const METRICS_TOKEN = 'x-metrics-ctrcs';

function buildMetricsHeaders(extra: Record<string, string> = {}): Record<string, string> {
  return {
    ...extra,
    Authorization: `Bearer ${METRICS_TOKEN}`,
  };
}

export async function fetchMetricsText(): Promise<string> {
  const res = await fetch('/metrics', {
    headers: buildMetricsHeaders({ Accept: 'text/plain' }),
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch metrics: ${res.status}`);
  }
  return res.text();
}
